import { type DocumentNode, gql } from '@apollo/client';

/**
 * Variables for validateSharedLinkToken mutation
 */
export interface ValidateSharedLinkTokenVariables {
  token: string;
}

/**
 * Validate shared link token payload structure
 */
export interface ValidateSharedLinkTokenPayload {
  payload: string;
}

/**
 * Response structure for validateSharedLinkToken mutation
 */
export interface ValidateSharedLinkTokenResponse {
  validateSharedLinkToken: ValidateSharedLinkTokenPayload;
}

const validateSharedLinkToken: DocumentNode = gql`
  mutation validateSharedLinkToken($token: String!) {
    validateSharedLinkToken(token: $token) {
      payload
    }
  }
`;

export default validateSharedLinkToken;
